import EditForm from '@/components/refinedev/pages/edit-form';
import {transformBeforeSave, UserForm} from './user-form';
import {SaveButton} from '@/components/refinedev/action_buttons';
// import ClassesInUserManager from './classes-in-user-manager';

const UserEdit = () => {
  return (
    <EditForm
      transformBeforeSave={transformBeforeSave}
      formProps={{
        refineCoreProps: {
          meta: {
            with: {staff: {with: ['department', 'job']}},            
          },
        },
      }}>
      <UserForm />
      <SaveButton className="mt-2" />
    </EditForm>
  );
};

export default UserEdit;
